var _ellipse, _rect, _path, _path2, _path3, _path4, _path5, _circle, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPegasusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 11.5,
    rx: 12.5,
    ry: 7.5,
    fill: "#61C0FF",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 19,
    width: 31,
    height: 6,
    rx: 3,
    fill: "#61C0FF",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13V2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13V2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.5H20.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3C13.5 2.44772 13.9477 2 14.5 2H18.5C19.0523 2 19.5 2.44772 19.5 3V10H13.5V3Z",
    fill: "#61C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8147 24.0062L12.7077 23.9831L10.8696 20.5832L15.0993 7.5192C15.0993 7.5192 21.4862 6.36011 22.6474 6.83557C23.8085 7.31102 25.2794 9.04346 25.2794 9.04346L27.1451 10.7733L26.8951 11.5662L21.7039 14.0001L18.2661 20.4032L17.8147 24.0062Z",
    fill: "url(#paint0_radial_1_844)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 19.5,
    r: 9.5,
    fill: "#2D67C5",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4154 24.5039L20.1904 20.2789C19.9365 20.025 19.9365 19.6135 20.1904 19.3596L21.1096 18.4404C21.3634 18.1865 21.775 18.1865 22.0288 18.4404L24.875 21.2865L30.9712 15.1904C31.225 14.9365 31.6366 14.9365 31.8904 15.1904L32.8096 16.1096C33.0635 16.3634 33.0635 16.775 32.8096 17.0289L25.3346 24.5039C25.0808 24.7577 24.6692 24.7577 24.4154 24.5039Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_844",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4911 16.0989) rotate(-156.595) scale(7.90862 11.5773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D67C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D67C5",
    stopOpacity: 0.01
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPegasusIcon);
export default __webpack_public_path__ + "static/media/pegasus-icon.475f61bed14adb89c8397fd2451ae122.svg";
export { ForwardRef as ReactComponent };